import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCountry, deleteCountry, getAllCountry, updateCountry } from '../../redux/rtk/features/masters/countrySlice';
import PageTitle from '../page-header/PageHeader';



const CountryMaster = () => {
  const { Title } = Typography;


  const [editingcountry, setEditingcountry] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.country);

  useEffect(() => {
    dispatch(getAllCountry());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingcountry) {
        // Update existing category
        const result = await dispatch(
          updateCountry({ id: editingcountry.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllCountry());
        } else {
          message.error('Error updating category!');
        }
      } else {
        // Add new category
        const result = await dispatch(addCountry(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllCountry());
        } else {
          message.error('Error adding category!');
        }
      }
      setEditingcountry(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update category!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteCountry(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllCountry());
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Country',
      dataIndex: 'countryName',
      key: 'countryName',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => { setEditingcountry(record); form.setFieldsValue(record); }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this country?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingcountry ? 'Edit Country' : 'Add Country'}>

            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="sub-category-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
              <Form.Item
                name="countryName"
                label="Country"
                rules={[{ required: true, message: 'Please enter a category!' }]}
              >
                <Input placeholder="Enter country" />
              </Form.Item>
              <Button type='primary' block htmlType='submit'>
                {editingcountry ? 'Update Country' : 'Add Country'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Country List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CountryMaster;
